<template>
	<div class="msg-analysis-rpd" v-if="!isError">
		<div class="msg-analysis-rpd-info">
			<span class="msg-analysis-rpd-img"></span>
			<span class="msg-analysis-rpd-text">{{message.receivertitle}}<br/>已领取</span>
		</div>
		<div class="msg-analysis-rpd-footer">
			<span>微信红包</span>
		</div>
	</div>
	<div class="msg-analysis-rp-error" v-else>
		红包消息格式错误，请在手机端查看！
	</div>
</template>

<script>
	import AppConfig from '../../../config/AppConfig.js'
	export default{
		name: 'MsgAnalysisRed_package_d',
		components:{
			
		},
		props:{
			msg:{
				  type:Object,
				  default:function(){
					  return {}
				  }
			}
		},
		data(){
			return {
				message: '',
				isError: false
			}
		},
		methods:{
			format(){
				try {
					this.message = JSON.parse(this.msg.content);
				}catch (e) {
					this.isError = true
				}
			}
		},
		
		created() {
			this.format()
		}
	}
</script>

<style>
	.msg-analysis-rp-error{
		background-color: #f19595;
		padding: 8px;
		font-size: 12px;
		border-radius: 2px;
	}
	.msg-analysis-rpd{
	    background: #ffffff;
	    position: relative;
	    border: 1px solid #e8e8e8;
	    cursor: pointer;
	    border-radius: 4px;
	    min-width: 200px;
	}
	.msg-analysis-rpd .msg-analysis-rpd-info{
	    background-image: -moz-linear-gradient(to left,#fbe3ca,#ffa685);
	    background-image: -o-linear-gradient(to left,#fbe3ca,#ffa685);
	    background-image: -webkit-linear-gradient(to left,#fbe3ca,#ffa685);
	    background-image: linear-gradient(to left,#fbe3ca,#ffa685);
	    height: 60px;
	    line-height: 60px;
	    display: flex;
	    flex-direction:row;
	    flex-wrap: nowrap;
	    justify-content: left;
	    align-items:center;
	    align-content: flex-start;
	    padding: 0 5px;
	    border-radius: 4px 4px 0 0;
	}
	.msg-analysis-rpd-info span{
	    display: block;
	    min-width: 30px;
	    max-width: 200px;
	    max-height: 60px;
	    overflow: hidden;
	    padding: 0 5px;
	    color: #ffffff;
	}
	.msg-analysis-rpd-info .msg-analysis-rpd-img{
	    width: 32px;
	    height: 32px;
	    padding: 0;
	    margin-right:5px;
	    margin-left:5px;
	    overflow: hidden;
	    background: url("/img/red_package_d.png") no-repeat;
	    background-size:32px 32px;
	}
	.msg-analysis-rpd-info .msg-analysis-rpd-text{
	    line-height: 18px;
	    height: 36px;
	    overflow: hidden;
	}
	.msg-analysis-rpd .msg-analysis-rpd-footer{
	    height: 20px;
	    line-height: 20px;
	    font-size: 12px;
	    color: #666666;
	    text-indent: 8px;
	}
</style>
